<template>
  <div
    class="bg-[#1e1e1f] px-5 py-5 md:px-12 md:py-10 text-left border border-[#383838] rounded-3xl text-amber-50 mx-3 mb-5 mt-3">
    <article data-page="about">

      <header>
        <div class="text-2xl font-bold text-white mb-5 fadein-bot title-section flex items-center">
          About Me &nbsp;
          <div class="h-[1px] w-32 bg-amber-200 md:w-96 aos-init aos-animate" data-aos="zoom-in-left"
            data-aos-duration="600"></div>
        </div>
      </header>

      <section
        class="text-sm md:text-lg text-justify flex flex-col gap-4 md:flex-row md:gap-8 md:justify-left md:items-center">
        <div class="flex justify-center">
          <img class="w-9/12 rounded-full mb-3 fadein-up pict"
            src="https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/IDFLLBMA-17115219024863b566a8d925c91990b8486e21b67e871.JPG"
            alt="Foto">
        </div>
        <div class="md:w-7/12">
          <ul class="mb-3 md:mb-7 fadein-left fadeins-1">
            <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">· Hi! 我是 WGG</li>
            <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">· 00后 现居 浙江杭州 </li>
            <!-- <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">· 身高181 CM ，体重80kg </li> -->
            <!-- <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">· 当前16型人格是ISTJ-A </li> -->
            <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">· 去思考，去做，去超越！ </li>
           
          </ul>

          <ul class="mb-3 md:mb-7 fadein-left fadeins-2">
            <!-- <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              · 2022年毕业于宁波财经-计算机科学与技术专业</li>
            <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">
              · 自2021年实习、工作以来，先后就职于多家互联网企业，这些经历为我的工作和成长给与了非常大的帮助</li> -->
            <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              · 现任职于悟川创新前端开发组</li>
            <!-- <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              ·非常感谢以下公司和同事给予的帮助与信任：杰克科技、目睹直播、趣看科技、美平米科技、悟川创新(排名不分先后)</li> -->
          </ul>
        </div>

      </section>

      <section
        class="text-sm md:text-lg text-justify flex flex-col gap-4 md:flex-row md:gap-8 md:justify-left md:items-center">
       
        <div class="md:w-7/12">
          <ul class="mb-3 md:mb-7 fadein-left fadeins-2">
            <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">
              · 我的爱好：摄影📷、汽车🚗、旅行🚄、音乐🎸、运动🏀、Fpv✈️、编程......</li>
            <!-- <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              · 我喜欢动植物，因为生命象征着希望和活力</li>
            <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              · 我喜欢艺术，因为艺术是带着诗意的土壤</li>
            <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">
              · 我追求生活的兴趣和激情，让每一天都充满活力、乐趣和青春的美好</li>
              <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              · 热爱学习各类方向技术知识,持续学习成长,不断充实和提高自己 </li> -->
            <li class="bg-clip-text bg-gradient-to-l from-slate-100 to-amber-300 text-transparent">
              · 生活是一次精彩的旅程，要不断尝试、挑战自我，慢慢成长
            </li>
            <li class="bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300 text-transparent">
              · 欢迎大家与我共同交流、共同学习、共同成长！很高兴认识你们~
            </li>
          </ul>
         
          <p class="mb-3 fadein-left fadeins-2">
            &nbsp; &nbsp; &nbsp;
            我擅长使用各种前端技术，包括HTML、CSS、JavaScript等，并熟悉流行的前端框架和工具，如React、Vue.js和Webpack。我能够将设计师的视觉概念转化为现实，并确保网站在各种浏览器和设备上的兼容性。
            如果您正在寻找一位有经验、有创意的前端开发者，我很乐意为您提供服务。请通过下方提供的联系方式与我取得联系，让我们一起创造出令人印象深刻的网站吧！
          </p>
        <!-- <img width="100" height="100"
                src="https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/CEODNAKO-1711513467263WechatIMG103.jpg"> -->
       
        </div>
        <div class="flex justify-center">
          <img class="w-9/12  mb-3 fadein-up pict"
            src="https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/CEODNAKO-1711513467263WechatIMG103.jpg"
            alt="Foto">
        </div>
      </section>
    </article>
  </div>

  <div class="px-5 py-5 md:px-12 md:py-10 text-left text-amber-50 mx-3">
    <article data-page="about">
      <header>
        <div class="text-2xl font-bold text-white mb-5 fadein-bot title-section flex items-center">
          <div class="h-[1px] w-10 bg-amber-200 md:w-20 aos-init aos-animate" data-aos="zoom-in-left"
            data-aos-duration="600"></div>
          &nbsp; Skills
        </div>
      </header>
      <section>
        <div>
          <ul class="flex flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400 mb-5">

            <li class="mr-2">
              <button class="inline-block px-4 py-3 rounded-lg hover:text-white"
                :class="{ 'text-amber-200 bg-amber-200 bg-opacity-10': activeTab === 2 }" @click="activeTab = 2">爱好
              </button>
            </li>
            <li class="mr-2">
              <button class="inline-block px-4 py-3 rounded-lg hover:text-white"
                :class="{ 'text-amber-200 bg-amber-200 bg-opacity-10': activeTab === 1 }" @click="activeTab = 1">编程
              </button>
            </li>
          </ul>
        </div>
        <div class="grid grid-cols-2 gap-4 pb-32 md:grid-cols-3 md:gap-8 xl:grid-cols-4 xl:gap-10 2xl:gap-12">
          <div v-for="item in tabListMap[activeTab]" :key="item.id">
            <div
              class="item-tech flex cursor-pointer items-center gap-2 rounded border border-amber-200 px-2 py-2 hover:bg-amber-200 hover:bg-opacity-10 md:gap-3 lg:px-3">
              <div class="flex h-12 w-12 items-center justify-center p-0 lg:h-16 lg:w-16 lg:p-2 zoom-in"
                v-if="item.imageUrl">
                <img alt="HTML" loading="lazy" width="32" height="32" decoding="async" data-nimg="1"
                  class="img-tech drop-shadow-xl transition-all duration-300 h-[65%] w-[65%] lg:h-[85%] lg:w-[85%]  "
                  :src="item.imageUrl" style="color: transparent;">
              </div>
              <div class="flex items-center text-sm md:text-base lg:text-lg">
                <div class="tech font-medium text-secondary transition-all duration-300 translate-y-0 ">
                  {{ item.name }}
                </div>
                <div
                  class="status-tech opacity-0 absolute mt-5 text-[10px] text-amber-200 transition-all duration-300 md:text-xs lg:text-sm">
                  {{ item.status }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeTab: 2,
      tabListMap: {
        1: [
          {
            id: 7,
            name: 'Taro',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/KADMOOEL-1711523726846taro.png',
            status: '熟练'
          },
          {
            id: 8,
            name: 'TS',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/DMLJOLIM-1711523726846typescript-def.png',
            status: '熟练'
          },
          {
            id: 9,
            name: 'VueJS',
            imageUrl: 'https://cdn.iconscout.com/icon/free/png-256/free-vue-282497.png?f=webp',
            status: '熟练'
          },
          {
            id: 10,
            name: 'ReactJS',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/GDJFPCAM-1711523779033React1.webp',
            status: '掌握'
          },
          {
            id: 4,
            name: 'MySQL',
            imageUrl: 'https://cdn-icons-png.flaticon.com/512/5968/5968313.png',
            status: '掌握'
          },
          {
            id: 5,
            name: 'SASS',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/HCBEPLJH-1711523726846SASS.png',
            status: '熟练'
          },
          {
            id: 6,
            name: 'LESS',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/ELFEFPKI-1711523940816less1.webp',
            status: '熟练'
          },
          {
            id: 11,
            name: 'Java',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/BLMHGCAG-1711523726845java.png',
            status: '掌握'
          },
        ],
        2: [
          {
            id: 1,
            name: '摄影',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/HBIEIGFH-1711527220347ps.jpg',
            status: '约拍走起'
          },
          {
            id: 1,
            name: '科技',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/GIHFPDIC-1711527332326car.png',
            status: '津津乐道'
          },
          {
            id: 1,
            name: '旅行',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/KKFHECPA-1711527494949旅行-06.png',
            status: '说走就走'
          },
          {
            id: 1,
            name: '音乐',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/IABNKLFL-1711527220347音乐.png',
            status: '多多欣赏'
          },
          {
            id: 1,
            name: '运动',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/PNCOCNAM-1711527445616Sport.png',
            status: '暂时搁置...'
          },
          {
            id: 1,
            name: 'FPV',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/MOPDFJGL-1711527445616飞机.png',
            status: '直接起飞'
          },
          {
            id: 1,
            name: '编程',
            imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/POEHEKLO-1711527220347027_编程.png',
            status: '高效优雅的追求'
          },
          
        ]
      }
    };
  },
}
</script>


<style>
.fadein-left {
  opacity: 0;
  font-size: 1.1rem;
  line-height: 2.2rem;
  animation: fadeInLeft 0.5s ease-out forwards;
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.fadeins-1 {
  animation-delay: 500ms;

}

.fadeins-2 {
  animation-delay: 800ms;
}

.img-tech,
.tech {
  transition: transform 0.3s ease;
}

.item-tech:hover .img-tech {
  transform: scale(1.3);
}

.item-tech:hover .tech {
  transform: translateY(-12px);
}

.item-tech:hover .status-tech {
  opacity: 1;
}

.pict {
  box-shadow: 0px 0px 43px -9px rgba(255, 219, 112, 0.44);

}
</style>
